import { createUseStyles } from 'react-jss'
import { theme as localTheme } from '../theme'

export const useStyles = createUseStyles(theme => ({
  formContainer: {
    '&.blue-bg': {
      '& form': {
        '& input': {
          backgroundColor: '#F0F8FF',
          border: '2px solid #F0F8FF',

          '&:focus': {
            backgroundColor: theme.colors.white,
          },
        },

        '& .error-message': {
          color: theme.colors.white,
        },

        '& .MuiCheckbox-root': {
          color: 'white',
        },

        '& .MuiCheckbox-colorSecondary.Mui-checked': {
          color: 'white',
        },

        '& .htmlLabel a, & .htmlLabel a:visited, & .htmlLabel a:active': {
          color: 'white',
        },
      },
    },

    '&.white-bg': {
      '& form': {
        '& input': {
          backgroundColor: '#F7F7F7',
          border: '2px solid #F7F7F7',

          '&:focus': {
            backgroundColor: '#F7F7F7',
          },
        },

        '& .error-message': {
          color: theme.colors.orange,
        },

        '& .MuiCheckbox-root': {
          color: theme.colors.darkgrey,
        },

        '& .MuiCheckbox-colorSecondary.Mui-checked': {
          color: theme.colors.darkgrey,
        },

        '& .htmlLabel a, & .htmlLabel a:visited, & .htmlLabel a:active': {
          color: theme.colors.darkgrey,
        },
      },
    },

    '& form': {
      '& .formSection': {
        marginBottom: '48px',
        display: 'grid',
        gridTemplateColumns: '1fr',
        gap: '20px',

        '@media (min-width: 768px)': {
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',

          '& h3': {
            gridColumn: '1 / -1',
          },
        },

        '& h3': {
          margin: '0 0 4px',
        },
      },

      '& .fieldContainer': {
        '&.fullWidth': { gridColumn: '1 / -1' },
        '&.error div[class*="control"]': { borderColor: `${theme.colors.orangeHover}8c` },
        '&.error input': { borderColor: `${theme.colors.orangeHover}8c` },
      },

      '& input': {
        height: '48px',
        width: '100%',
        padding: '10px 24px',
        borderRadius: '17px',
        boxSizing: 'border-box!important',
        color: theme.colors.darkgrey,

        '&::placeholder': {
          color: theme.colors.darkgrey,
        },

        '&.error': {
          borderColor: `${theme.colors.orangeHover}8c`,
        },
      },

      '& .error-message': {
        color: theme.colors.white,
        display: 'flex',
        fontSize: '12px',
        alignItems: 'center',
        paddingTop: '7px',

        '& img': {
          width: '12px',
          height: '12px',
          marginRight: '5px',
        },
      },

      '& .formControls': {
        display: 'flex',
        justifyContent: 'space-between',

        '& .button': {
          padding: '13px 24px',
          borderRadius: '15px',
          fontSize: '15px',

          '&.buttonNext, &.buttonSubmit': {
            justifySelf: 'flex-end',
            marginLeft: 'auto',
            color: theme.colors.white,
            backgroundColor: theme.colors.orange,
            border: 'none',
            cursor: 'pointer',

            '&:hover': {
              backgroundColor: theme.colors.orangeHover,
            },
          },

          '&.buttonPrevious': {
            border: 'none',
            cursor: 'pointer',
            color: theme.colors.black,
            backgroundColor: theme.colors.lightgrey,

            '&:hover': {
              color: theme.colors.white,
              backgroundColor: theme.colors.darkgrey,
            },
          },
        },
      },

      '& .button.buttonNext, & .button.buttonSubmit': {
        justifySelf: 'flex-end',
        marginLeft: 'auto',
        color: theme.colors.white,
        backgroundColor: theme.colors.orange,
        border: 'none',
        cursor: 'pointer',

        '&:hover': {
          backgroundColor: theme.colors.orangeHover,
        },
      },

      '& .select__control--menu-is-open': {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
      },

      '& .select__menu': {
        marginTop: 0,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
      },

      '& .smallLabel .MuiTypography-root.MuiFormControlLabel-label.MuiTypography-body1': {
        fontSize: '15px',
        fontWeight: '300',
      },

      '& .fieldDescription': {
        fontSize: '13px',
        fontWeight: '300',
      },
    },
  },
}))

export const selectStyles = {
  control: styles => ({
    ...styles,
    backgroundColor: '#F0F8FF',
    border: '2px solid #F0F8FF',
    fontSize: 12,
    borderRadius: 17,
    ':hover, :focus, :active': {
      border: '2px solid #F0F8FF',
      outline: 'none',
    },
  }),
  option: (styles, { isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isDisabled
        ? null
        : isSelected
        ? localTheme.colors.sunflower
        : isFocused
        ? null
        : null,
      color: '#4E4E4E',
      cursor: isDisabled ? 'not-allowed' : 'default',
      fontSize: '14px',
      fontWeight: isSelected ? 500 : 300,
      lineHeight: '19px',
      paddingLeft: 25,
      ':active': {
        ...styles[':active'],
        backgroundColor: localTheme.colors.sunflower,
      },
      ':hover': {
        ...styles[':hover'],
        backgroundColor: localTheme.colors.sunflower,
      },
    }
  },
  container: () => ({
    borderRadius: 17,
    position: 'relative',
    boxSizing: 'border-box',
  }),
  dropdownIndicator: base => ({
    ...base,
    color: localTheme.colors.main,
    ':hover': {
      color: localTheme.colors.main,
    },
  }),
  valueContainer: () => ({
    backgroundColor: 'transparent',
    border: 'none',
    boxShadow: 'none',
    padding: '10px 20px',
    fontSize: 12,
    borderRadius: 17,
    overflow: 'hidden',
    height: 48,
    boxSizing: 'border-box',
  }),
  placeholder: () => ({
    color: '#000',
    paddingTop: '8px',
  }),
  menu: styles => ({
    ...styles,
    borderRadius: 17,
    overflow: 'hidden',
    padding: '0',
    margin: '0',
  }),
  menuList: styles => ({
    ...styles,
    padding: '0',
    margin: '0',
    backgroundColor: localTheme.colors.lightgrey,
  }),
}
